const serviceTerms = [
    { 
        id: "overview",
        title: "1. Overview", 
        content: [
            "This section provides a high-level summary of the terms governing your participation in and use of the Siraj Islamic Center’s programs, events, and facilities.",
            "By attending our activities, using our resources, or engaging with our services, you agree to abide by the guidelines and values set forth in these Terms & Conditions, rooted in Islamic principles."
        ]
    }, 
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Conduct", 
        content: [
            "All visitors, members, and participants must uphold respectful and ethical behavior in accordance with Islamic teachings and community guidelines.",
            "Activities such as disruptive behavior, misuse of center facilities, or actions that contradict our mission and values are strictly prohibited."
        ]
    },
    { 
        id: "registration", 
        title: "3. Registration & Donations", 
        content: [
            "Enrollment in classes, events, or programs requires prior registration through our official channels.",
            "Donations and contributions must be made through approved methods, and receipts will be issued upon request.",
            "Failure to complete registration or meet donation commitments may result in loss of reserved spots or participation rights."
        ]
    },
    { 
        id: "member-responsibilities", 
        title: "4. Member Responsibilities", 
        content: [
            "Members are responsible for providing accurate information during registration or volunteer sign-up.",
            "All participants must maintain cleanliness, modesty, and respectful interaction within the premises.",
            "Any safety concerns, lost property, or inappropriate conduct should be reported immediately to the center’s administration."
        ]
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: [
            "The Siraj Islamic Center shall not be held liable for personal belongings lost or damaged on our premises.",
            "We are also not responsible for injuries, delays, or disruptions caused by factors beyond our control, including extreme weather events or third-party service interruptions."
        ]
    },
    { 
        id: "termination", 
        title: "6. Termination of Access", 
        content: [
            "We reserve the right to revoke access to our programs or facilities in cases of serious violations of these Terms & Conditions.",
            "Such actions may be taken with or without prior notice, depending on the nature of the breach."
        ]
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: [
            "All materials, class content, publications, and designs produced by the Siraj Islamic Center remain the intellectual property of the center.",
            "These resources may only be used for personal and non-commercial purposes, unless written permission is granted."
        ]
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: [
            "These Terms & Conditions are governed by the laws of [Your Country/State] in accordance with Islamic ethics.",
            "Any disputes shall be resolved respectfully through community mediation before pursuing legal avenues in [City/Region]."
        ]
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: [
            "For questions or concerns regarding these Terms & Conditions or our services, please reach out to us:",
            "Email: info@sirajcenter.com",
            "Phone: +[Your Phone Number]"
        ]
    }
];

export default serviceTerms;